import React, { useEffect, useMemo, useState } from 'react';
import {
  filterTreeBySearch,
  TreeFilterKeys,
  TreeFilterOption,
} from '@zonofi/zono-money-store';
import './tree-filter-item.scss';
import { SearchBar } from '../search-bar';
import { TreeNodeItem } from './tree-node-item';
import { isEmpty } from 'lodash';
import { EmptyStateView } from '../empty-state';
import { SVGS } from '@zonofi/seller-hub/assets';

interface TreeFilterItemProps {
  filterKey?: TreeFilterKeys;
  data: TreeFilterOption;
  onItemPress: (id: string, hasChildren?: boolean) => void;
  needSearch?: boolean;
}

export const TreeFilterItem: React.FC<TreeFilterItemProps> = ({
  filterKey = '',
  data,
  onItemPress,
  needSearch = false,
}) => {
  const [value, setValue] = useState('');
  useEffect(() => {
    setValue('');
  }, [filterKey]);

  const filteredData = useMemo(() => {
    return filterTreeBySearch(data?.value || [], value);
  }, [data?.value, value]);

  return (
    <div className="tree-filter-container">
      {filterKey && (
        <div className="tree-filter-container__heading font-semibold">
          {filterKey?.toUpperCase()}
        </div>
      )}
      {needSearch && (
        <SearchBar
          placeholderText={`Search by ${filterKey}`}
          className="filter-modal-search"
          inputClassName="font-regular"
          value={value}
          onChange={setValue}
        />
      )}
      <div className="tree-filter-item-view">
        {value && isEmpty(filteredData) ? (
          <EmptyStateView
            imageSrc={SVGS.NoSearchIcon}
            message={'No Results Found'}
            description="No results match your search."
          />
        ) : (
          filteredData?.map((item) => (
            <TreeNodeItem key={item.id} data={item} onItemPress={onItemPress} />
          ))
        )}
      </div>
    </div>
  );
};
